import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import axios from "axios";

const LiveStatusTable = ({ buildingId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!buildingId) return;
      
      try {
        setLoading(true);
        // Using the operations/building/:id endpoint which now returns the extra fields
        // BaseURL already includes /api
        const response = await axios.get(`/operations/building/${buildingId}`);
        setData(response.data);
        setError(null);
      } catch (err) {
        console.error("Error fetching live status:", err);
        const errMsg = err.response?.data?.message || err.message || "Failed to load data";
        setError(errMsg);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 60000); // Refresh every 60s
    return () => clearInterval(interval);
  }, [buildingId]);

  if (loading && !data) return <div>Loading...</div>;
  if (error) return <div className="text-danger">{error}</div>;
  if (!data) return null;

  return (
    <div className="table-responsive">
      <Table className="table-hover table-striped mb-0">
        <thead>
          <tr>
            <th>Parameter</th>
            <th className="text-right">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>IL Status</td>
            <td className="text-right">
              <span 
                className="badge" 
                style={{
                  backgroundColor: data.ilStatus === 'Inactive' ? '#6c757d' : '#28a745',
                  color: '#fff',
                  fontSize: '1rem',
                  padding: '8px 12px'
                }}
              >
                {data.ilStatus}
              </span>
            </td>
          </tr>
          <tr>
            <td>DR Status</td>
            <td className="text-right">
              <span 
                className="badge" 
                style={{
                  backgroundColor: data.drStatus === 'Inactive' ? '#6c757d' : '#28a745',
                  color: '#fff',
                  fontSize: '1rem',
                  padding: '8px 12px'
                }}
              >
                {data.drStatus}
              </span>
            </td>
          </tr>
          <tr>
            <td>Participated Load</td>
            <td className="text-right" style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
              {data.participatedLoad?.toFixed(2)} kW
            </td>
          </tr>
          <tr>
            <td>Contracted Capacity</td>
            <td className="text-right" style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
              {data.contractedCapacity?.toFixed(2)} kW
            </td>
          </tr>
          <tr>
            <td>Threshold (Available)</td>
            <td className="text-right" style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
              <span className={data.threshold < 0 ? "text-danger" : "text-success"}>
                {data.threshold?.toFixed(2)} kW
              </span>
            </td>
          </tr>
          <tr>
            <td>Current Load</td>
            <td className="text-right" style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
              {data.currentLoad?.toFixed(2)} kW
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default LiveStatusTable;

